
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { DateTimeSlot } from '@/types/dashboard';

interface DateTimeSelectorProps {
  selectedDate: string;
  selectedTime: string;
  availableSlots: DateTimeSlot[];
  isDisabled: boolean;
  onDateChange: (date: string) => void;
  onTimeChange: (time: string) => void;
}

const DateTimeSelector: React.FC<DateTimeSelectorProps> = ({
  selectedDate,
  selectedTime,
  availableSlots,
  isDisabled,
  onDateChange,
  onTimeChange
}) => {
  // Gerar opções de horário disponíveis
  const timeOptions = availableSlots.map(slot => {
    return {
      value: slot.startTime.substring(0, 5), // Get HH:MM format
      label: `${slot.startTime.substring(0, 5)} - ${slot.endTime.substring(0, 5)}`
    };
  });

  return (
    <>
      <div>
        <Label htmlFor="new-date">Nova data *</Label>
        <Input
          id="new-date"
          type="date"
          value={selectedDate}
          onChange={(e) => onDateChange(e.target.value)}
          min={new Date().toISOString().split('T')[0]}
          className="mt-1"
          disabled={isDisabled}
        />
      </div>

      {selectedDate && (
        <div>
          <Label htmlFor="new-time">Novo horário *</Label>
          <select
            id="new-time"
            value={selectedTime}
            onChange={(e) => onTimeChange(e.target.value)}
            className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            disabled={isDisabled}
          >
            <option value="">Selecione um horário</option>
            {timeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {timeOptions.length === 0 && selectedDate && (
            <p className="text-sm text-muted-foreground mt-1">
              Nenhum horário disponível para esta data
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default DateTimeSelector;
